import type { ConnectorWithOAuth } from "../../../shared/connectors/getTargetValue";
import type { CopyableItem } from "../../../shared/connectors/types";
import { Box } from "../Box";
import { Text } from "../Text";
import { CopyableValue } from "../Settings/CopyableValue";
import { useRenderWithPlaceholders } from "./renderWithPlaceholders";

export function CopyableFieldItem({
  item,
  app,
}: {
  item: CopyableItem;
  app: ConnectorWithOAuth;
}) {
  const renderWithPlaceholders = useRenderWithPlaceholders();
  const value = renderWithPlaceholders(
    typeof item.value === "function"
      ? item.value(app.configuration)
      : item.value,
    {
      CONNECTED_APP_ID: app.id,
    }
  );

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Box horizontal={8} vertical={10}>
        <Text variant="text-small-md" color="var(--text-primary)">
          {item.label}
        </Text>
      </Box>
      <CopyableValue value={value}>
        <Text
          variant="text-regular"
          color="var(--text-secondary)"
          ellipsis
          style={{ flex: 1 }}
        >
          {value}
        </Text>
      </CopyableValue>
    </div>
  );
}
